import React from "react"
import autobind from "class-autobind"
import { Toggle, RaisedButton } from "material-ui"
import AppStateStore from "../../../stores/AppStateStore"
import strings from "../../../localization/strings"
import AddAgreementDialog from "./AddAgreementDialog"
import { IPrivacyAgreementDocument } from "../../../models"
import * as api from "../../../api"
import AccountStore from "../../../stores/AccountStore"
import { red500 } from "material-ui/styles/colors"
import * as accountActions from "../../../actions/AccountActions"
interface IProps {
    finddAgreement: boolean
    requireAgreement: boolean
    cannotDisable?: boolean
    handleRequireAgreement?(requireAgreement: boolean): void
}
interface IState {
    requireAgreement: boolean
    latestAgreement: IPrivacyAgreementDocument
    openAddAgreementTextDialog: boolean
}

export default class AgreementSet extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            requireAgreement: props.requireAgreement,
            latestAgreement: null,
            openAddAgreementTextDialog: false,
        }
        autobind(this)
    }

    componentDidMount() {
        this.getLatestAgreement()
    }

    getLatestAgreement() {
        api.getLatestPrivacy(this.props.finddAgreement ? "" : AccountStore.getCurrentAccount().Id).then(res =>
            this.setState({ latestAgreement: res.data })
        )
    }

    render() {
        return !AppStateStore.hideAgreementFeature &&
            <div style={{ display: "flex", position: "relative" }}>
                {this.state.requireAgreement && !this.state.latestAgreement &&
                    <span style={{ position: "absolute", top: 20, fontSize: 12, color: red500 }}>
                        {strings.Warning_If_you_dont_input_an_Agreement_it_will_be_off}
                    </span>
                }
                <Toggle
                    data-intercom-target={"AgreementSet-Toggle-RequireAgreement"}
                    toggled={this.state.requireAgreement}
                    onToggle={(event, value) => {
                        this.setState({ requireAgreement: value })
                        if (!value || this.state.latestAgreement)
                            this.props.handleRequireAgreement &&
                                this.props.handleRequireAgreement(value)
                    }}
                    labelPosition="left"
                    label={strings.Require_Agreement_Before_Training_Punching}
                    style={{ width: 350 }}
                    disabled={this.state.requireAgreement && this.state.latestAgreement && this.props.cannotDisable}
                />
                {this.state.requireAgreement &&
                    <RaisedButton
                        data-intercom-target={"AgreementSet-Btn-AgreementText"}
                        label={strings.Agreement_Text}
                        style={{ marginLeft: 60, marginTop: -8 }}
                        labelStyle={{ textTransform: "unset" }}
                        onClick={() => this.setState({ openAddAgreementTextDialog: true })}
                    />
                }
                {this.state.openAddAgreementTextDialog &&
                    <AddAgreementDialog
                        latestAgreement={this.state.latestAgreement}
                        handleClose={() => this.setState({ openAddAgreementTextDialog: false })}
                        handleUpdate={agreement => {
                            api.updateAccountAgreement(agreement).then(() => this.getLatestAgreement())
                            this.setState({ openAddAgreementTextDialog: false })
                        }}
                        handleCreate={newAgreement => {
                            newAgreement.AccountId = this.props.finddAgreement ? null : AccountStore.getCurrentAccount().Id
                            this.setState({ openAddAgreementTextDialog: false })
                            this.props.handleRequireAgreement &&
                                this.props.handleRequireAgreement(true)
                            accountActions.createAgreement(newAgreement, this.getLatestAgreement)
                        }}
                    />
                }
            </div>
    }
} 